import React from 'react';
import { useField } from 'formik';
import classNames from 'classnames';
import { CFormGroup, CInput, CLabel } from '@coreui/react';
import { startCase } from 'lodash';

interface ColorPickerProps {
  name: string;
  disabled?: boolean;
}

const ColorPicker = (props: ColorPickerProps) => {
  const {
    name,
    disabled
  } = props;

  const [field, meta] = useField(name);

  const isInvalid = () => meta.touched && meta.error;

  return (
    <CFormGroup className="mb-2">
      <CLabel htmlFor={name}>{startCase(name.split('.').pop())}</CLabel>
      <div className="d-flex align-items-center">
        <CInput
          name={name}
          className={`mr-2 ${classNames({ 'is-invalid': isInvalid() })}`}
          disabled={disabled}
          {...field}
        />
        <CInput
          style={{width: '50px'}}
          className="px-2"
          type="color"
          disabled={disabled}
          {...field}
        />
      </div>
      {isInvalid() && <div>{meta.error}</div>}
    </CFormGroup>
  );
};

ColorPicker.defaultProps = {
  disabled: false
};

export default ColorPicker;
